import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-card",
  "use": "icon-icon-card-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-card\"><path d=\"M1024 455.111v341.333a113.778 113.778 0 0 1-113.778 113.778H113.778A113.778 113.778 0 0 1 0 796.444V455.111h1024zM853.333 682.667H625.778v113.777h227.555V682.667zm56.89-568.89A113.778 113.778 0 0 1 1024 227.557v113.777H0V227.556a113.778 113.778 0 0 1 113.778-113.778h796.444z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol